import React from 'react';

const HierarchicalMapChart = ({ data }) => {
  return (
    <div className="w-full h-full">
      <div className="chart-header">
        <h3 className="chart-title">Mapa Jerárquico del Gasto</h3>
        <p className="chart-subtitle">Trazabilidad organizacional</p>
      </div>
      <div className="chart-content">
        <div className="flex items-center justify-center h-64 text-gray-500">
          <div className="text-center">
            <div className="text-4xl mb-2">🗺️</div>
            <p>Estructura jerárquica</p>
          </div>
        </div>
      </div>
      <div className="chart-footer">
        <div className="chart-insight">Múltiples niveles organizacionales</div>
        <div className="chart-metric">Por implementar</div>
      </div>
    </div>
  );
};

export default HierarchicalMapChart; 